export default __webpack_public_path__ + "static/media/infografico_3_dominios.eb31c123.png";